var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconYogaColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BA68C8",
    d: "M11.957 24.458c-.431 0-.84-.26-1.01-.684-1.151-2.879-1.164-9.89-1.164-10.187 0-.6.487-1.087 1.087-1.087s2.174-.057 2.174.543c0 .99-1.24 3.975-.611 7.71.149.886.315 1.667.533 2.213a1.088 1.088 0 01-1.009 1.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M12.5 2.717a2.175 2.175 0 11-.002 4.35 2.175 2.175 0 01.002-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA68C8",
    d: "M14.132 19.565a1.086 1.086 0 01-.68-1.936l1.692-1.353-2.644-1.602c-.456-.39-.672-1.881-.282-2.338.392-.455 1.458-.77 1.913-.38l3.425 3.523a1.085 1.085 0 01-.029 1.674l-2.718 2.174c-.2.16-.44.238-.678.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M11.413 10.326h-1.63L7.062 5.864a.817.817 0 01-.02-.77l2.282-4.1a.816.816 0 011.458.73l-2.087 3.71 2.717 3.263v1.63zm2.174 0h1.63l2.72-4.461a.817.817 0 00.02-.77L15.747.941a.815.815 0 10-1.46.73l2.018 3.764-2.718 3.26v1.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF66A1",
    d: "M15.218 13.043L9.782 14.13v-3.804c.6 0 1.087-.487 1.087-1.087V8.152h3.26V9.24c0 .6.487 1.087 1.088 1.087v2.717z"
  }))));
}

export default SvgCommonIconYogaColor;